import { getIconBaseProps } from '../utils';

export const etf = {
  ...getIconBaseProps('etf'),
  width: '28px',
  height: '28px',
  viewBox: '0 0 28 28',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  body: (
    <>
      <path
        d='M5.35602 18.9391C8.14752 23.7787 14.33 25.4368 19.165 22.6427C21.3933 21.355 22.9465 19.3464 23.7004 17.0811C23.8073 16.7597 23.5985 16.4261 23.2664 16.3602L20.2278 15.7572C19.6382 15.6402 19.0661 15.991 18.771 16.5152C18.3163 17.3225 17.6464 18.0222 16.7865 18.5191C14.2268 19.9983 10.9537 19.1205 9.47582 16.5584C7.99797 13.9963 8.87499 10.7201 11.4347 9.24089C11.4883 9.20994 11.5421 9.18001 11.5963 9.15111C12.112 8.87601 12.4701 8.33465 12.3874 7.75562L11.9404 4.62542C11.8935 4.29655 11.5751 4.07678 11.2567 4.17081C10.5042 4.39309 9.76564 4.70724 9.05613 5.11726C4.22112 7.91135 2.56453 14.0996 5.35602 18.9391Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.1077 11.9602C19.0084 11.7022 18.8878 11.4486 18.7453 11.2016C18.0965 10.0767 17.1016 9.27654 15.973 8.85791C15.4039 8.64681 14.9648 8.12855 14.9941 7.52175L15.1118 5.07684C15.1447 4.39312 15.7482 3.87171 16.4141 4.02782C19.0379 4.64299 21.4114 6.30049 22.8651 8.82082C23.3881 9.7274 23.7549 10.6813 23.974 11.6514C24.1294 12.3394 23.5669 12.9461 22.8622 12.9384L20.3511 12.911C19.7831 12.9048 19.3119 12.4908 19.1077 11.9602Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  ),
};
